import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { registerBackgroundReconcile } from './lib/swTimerBridge';
import { markPwaUpdateReady } from './lib/pwaUpdate';
import { platform } from './lib/client';
import { applyTheme, getStoredTheme } from './utils/theme';
import App from './App.tsx';
import './index.css';

// Match the saved app theme before the timer's loading screen is rendered.
applyTheme(getStoredTheme());

// Register service worker (vite-plugin-pwa handles dev + production paths).
// registerType is 'prompt': a new version waits until the user refreshes via
// the in-app toast — an auto-reload would kill a running pomodoro.
const updateSW = registerSW({
  onNeedRefresh() {
    markPwaUpdateReady(() => updateSW(true));
  },
  immediate: true
});

// Let the SW wake in the background to fire timer notifications (where supported)
void platform.audioCache.initialize().catch(() => undefined);
void registerBackgroundReconcile();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
